export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm';
export const PRECISE_DATE_TIME_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const TIME_FORMAT = 'HH:mm';
export const DATE_MOMENT_FORMAT = 'll';
